<template>
    <div>
        <div class="page-block__actions">
            <div class="page-block__actions-item">
                <div class="u-text-right">
                    <button
                        v-if="canCancel"
                        @click="showModal"
                        type="button"
                        class="btn btn--link"
                        dusk="cancel-button"
                    >
                        <strong>{{ trans('page.services.cancel-transfer-link') }}</strong>
                        <img src="../assets/icomoon/SVG/arrow-right-orange.svg" class="u-margin-left-inline" />
                    </button>
                </div>
            </div>
        </div>

        <service-cancel-modal
            v-if="cancelModalVisible"
            @close="closeModal"
            :domain="domain"
            :subscriptions="servicesByDomain"
        />
    </div>
</template>

<script>
import ServiceCancelModal from './ServiceCancelModal';
import serviceMixin from '../mixins/service.js';

export default {
    components: {
        ServiceCancelModal
    },
    mixins: [serviceMixin],
    props: {
        subscription: {
            type: Object,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            cancelModalVisible: false
        };
    },
    computed: {
        /**
         * Checks if the subscription is active.
         *
         * @return {boolean}
         */
        isActive() {
            return this.subscription.administrative_status === 'active';
        },
        /**
         * Checks if the current user can cancel the subscription
         *
         * @return {boolean}
         */
        canCancel() {
            return this.isActive && this.subscription.available_actions.includes('cancel');
        }
    },
    methods: {
        /**
         * Show the modal.
         */
        showModal() {
            this.cancelModalVisible = true;
        },

        /**
         * Close the modal.
         */
        closeModal() {
            this.cancelModalVisible = false;
        }
    }
};
</script>
